export class BookingType {
    readonly id: number;
    readonly name: string;

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public static PermSubmission = new BookingType(10, "Perm Submission");
    public static PermInterview = new BookingType(90, "Perm Interview");
    public static PermHire = new BookingType(20, "Perm Hire");
    public static ContractSubmission = new BookingType(
        30,
        "Contract Submission"
    );
    public static ContractInterview = new BookingType(
        100,
        "Contract Interview"
    );

    public static ContractHire = new BookingType(40, "Contract Hire");
    public static Custom = new BookingType(50, "Custom");
    public static PostingFee = new BookingType(60, "Posting Fee");
    public static MonthlySubscription = new BookingType(
        70,
        "Monthly Subscription"
    );
    public static QuarterlySubscription = new BookingType(
        75,
        "Quarterly Subscription"
    );
    public static AnnualSubscription = new BookingType(
        80,
        "Annual Subscription"
    );
    public static OneTimeSubscription = new BookingType(
        110,
        "One Time Subscription"
    );

    static asArray = () => [
        BookingType.PermSubmission,
        BookingType.PermInterview,
        BookingType.PermHire,
        BookingType.ContractSubmission,
        BookingType.ContractInterview,
        BookingType.ContractHire,
        BookingType.Custom,
        BookingType.PostingFee,
        BookingType.MonthlySubscription,
        BookingType.QuarterlySubscription,
        BookingType.AnnualSubscription,
        BookingType.OneTimeSubscription
    ];

    public static fromId = (id: number) =>
        BookingType.asArray().find(i => i.id === id);

    public static isSubmission = (id: number) =>
        [BookingType.PermSubmission, BookingType.ContractSubmission].some(
            t => t.id === id
        );

    public static isHire = (id: number) =>
        [BookingType.PermHire, BookingType.ContractHire].some(t => t.id === id);

    public isSubmission = () => BookingType.isSubmission(this.id);

    public isHire = () => BookingType.isHire(this.id);

    public isPermSubmission = () => this.id === BookingType.PermSubmission.id;
    public isPermHire = () => this.id === BookingType.PermHire.id;
    public isContractHire = () => this.id === BookingType.ContractHire.id;
    public isContractSubmission = () =>
        this.id === BookingType.ContractSubmission.id;
    public isCustom = () => this.id === BookingType.Custom.id;
    public isPostingFee = () => this.id === BookingType.PostingFee.id;
    public isMonthlySubscription = () =>
        this.id === BookingType.MonthlySubscription.id;
    public isQuarterlySubscription = () =>
        this.id === BookingType.QuarterlySubscription.id;
    public isAnnualSubscription = () =>
        this.id === BookingType.AnnualSubscription.id;
}
